export enum Locales {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  TR = 'tr',
}

export const LOCALES = [
  { value: Locales.DE, caption: 'Deutsch' },
  { value: Locales.EN, caption: 'English' },
  { value: Locales.FR, caption: 'Français' },
  { value: Locales.TR, caption: 'Türkçe' },
];
